var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRelevant)?_c('i',{staticClass:"tm-audio-shadow"},_vm._l((_vm.trackRectangles),function(rectangle,i){return _c('tm-audio-shadow-span',{key:i,attrs:{"track":_vm.track,"rectangle":rectangle,"isFirst":i === 0}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }